import { useNavigate, useLocation } from "react-router-dom";
import FaceLoginCamera from "../components/FaceLoginCamera";

const API_URL =
    import.meta.env.VITE_FACE_API ||
    "https://secureapi-prod-dccvbqhwh6fkeyfh.centralus-01.azurewebsites.net";

export default function CandidateFaceLogin() {
    const navigate = useNavigate();
    const location = useLocation();
    const email = (location.state as { email?: string })?.email ?? "";

    const handleCapture = async (blob: Blob) => {
        try {
            const formData = new FormData();
            formData.append("Image", blob, "photo.jpg");

            const response = await fetch(`${API_URL}/api/face/match?email=${encodeURIComponent(email)}`, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();

            if (data.match) {
                alert("✅ Face verified! Redirecting...");
                navigate("/candidate/dashboard");
            } else {
                alert("❌ Face not recognized. Use your 6-digit code instead.");
                navigate("/candidate/login");
            }
        } catch (err) {
            console.error(err);
            alert("⚠️ Error verifying face.");
        }
    };

    return (
        <div className="max-w-md mx-auto p-4">
            <h1 className="text-2xl font-bold mb-3 text-center">Face Login</h1>
            <FaceLoginCamera onCapture={handleCapture} />
        </div>
    );
}
